var _defs, _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M15.06 17.69a8.066 8.066 0 01-.62-9.88"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 28.58,
    cy: 7.9,
    r: 1.77,
    transform: "rotate(-31.63 28.593 7.908)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M26.645 14.597l.023-2.12 4.35.048-.024 2.12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M27.16 33.5c-.89-.15-1.79-.45-2.64-.9-4.38-2.31-6.06-7.73-3.75-12.12s7.74-6.07 12.12-3.76 6.07 7.74 3.75 12.13a8.635 8.635 0 01-3.11 3.36M26.645 14.597l.023-2.12 4.35.048-.024 2.12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M27.16 33.5c-.89-.15-1.79-.45-2.64-.9-4.38-2.31-6.06-7.73-3.75-12.12s7.74-6.07 12.12-3.76 6.07 7.74 3.75 12.13a8.635 8.635 0 01-3.11 3.36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M11.486 16.083l4.35-.048.023 2.12-4.35.047z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M15.37 37.06a8.64 8.64 0 002.63-.9 8.975 8.975 0 004.35-5.17M8.98 35.78a8.686 8.686 0 01-3.1-3.36 8.96 8.96 0 013.75-12.13 8.965 8.965 0 0110.55 1.62M11.486 16.083l4.35-.048.023 2.12-4.35.047z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M15.37 37.06a8.64 8.64 0 002.63-.9 8.975 8.975 0 004.35-5.17M8.98 35.78a8.686 8.686 0 01-3.1-3.36 8.96 8.96 0 013.75-12.13 8.965 8.965 0 0110.55 1.62"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M17.51 5.13c.85-.43 1.81-.71 2.81-.81 1.55-.15 3.05.14 4.35.79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustody);
export default __webpack_public_path__ + "static/media/Custody.419b12b0a4b4a559693944035e048b07.svg";
export { ForwardRef as ReactComponent };